import React,{ useEffect, useContext, useState, useRef } from "react";
// Components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderPp } from "../../../components/Landing/Header/haederPp";
import { BreadCrumb } from "../../../components/Landing/Breadcrumb/breadcrumb.view";
import { Cards } from "../components/Cards/cards";
import { ModalVisualizarCronograma } from "./components/Avisos/ModalVisualizarCronograma";
import { ModalVisualizarPortafolio } from "./components/Avisos/ModalVisualizarPortafolio";
import { ModalVisualizarSocializaciones } from "./components/Avisos/ModalVisualizarSocializaciones";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { AiFillFacebook, AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { Footer } from "../../../components/Landing/Footer";
import { Banner } from "../components/Banner/Banner";
import { useNavigate } from "react-router-dom";
import getStorageUser from "../../../middlewares/GetStorageUser"
import { Form, Select, Input, Button, Collapse, Table, Empty, Row, Col, Popover, Space, Carousel } from "antd";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";
import { QuienParticipaOptions, tipoConvocatoria } from "../../../utils/dataSelectOptions";
import { TemplateContext } from "../../../utils/template_context";
import apiMaestras from "../../../api/Maestras/api-maestras";

import '../PeopleList.scss';

import segundaMobile from "../../../assets/pp/banner principal forta.png";
import segundaDesktop from "../../../assets/pp/banner principal forta.png";
import banner2 from "../../../assets/pp/RESENA FORTALE 2.png"
import banner3 from "../../../assets/pp/RESENA FORTALE 1.png"
import botonEstimulos from "../../../assets/pp/Boton Estimulos.jpg";
import botonCronograma from "../../../assets/pp/Boton Cronograma.jpg";
import botonSocializaciones from "../../../assets/pp/Banne-3.jpg";


import img1 from "../../../assets/pp/8805165.png";
import observatorio from "../../../assets/pp/observatorio.png";
import investigacion from "../../../assets/pp/investigacion.png";
import planes from "../../../assets/pp/planes.png";



// Hook
import { useLanding } from "../../../hooks/useLanding";
// style
import "../landing.style.scss";
import { color } from "html2canvas/dist/types/css/types/color";
import { borderBottomStyle } from "html2canvas/dist/types/css/property-descriptors/border-style";

const routes = [
  { icon: <></>, nombre: "Alcaldía de Medellín" },
  { icon: <></>, nombre: "Secretaría Cultura Ciudadana" },
  { icon: <></>, nombre: "Convocatorias de Presupuesto Participativo" },
];
const coloresEstado = {
  Abierta: "#21BA45",
  "En espera": "#EFC236",
  Cerrada: "#9F0505",
};
const { Panel } = Collapse;

const blockquoteStyle = {
  background: '#FFF',
  border: 0,
  margin: '1px',
  padding: 0,
  boxShadow: 'none',
  display: 'block'
};

const divStyle = {
  padding: '16px'
};

const linkStyle = {
  color: '#000',
  fontFamily: 'Arial, sans-serif',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: '17px',
  textDecoration: 'none'
};

const divCarrusel = {
  backgroundColor: '#efefef',
  padding: '20px',
  borderRadius: '10px'
}

export const PpFortalecimiento = () => {
  // state component
  const {
    principalState,
    getConvocatorias,
    getSiguientesConvocatorias,
    visibleButton,
    setPrincipalState,
    buscarconvocatorias,
    limipiarfiltros,
    loadingConvocatorias
  } = useLanding();

  const navigate = useNavigate();

  React.useEffect(() => {
    getLineasConvocatorias();
  }, []);

  useEffect(() => {
    // Crear un script y añadirlo al DOM
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Limpiar el script cuando el componente se desmonte
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const context = useContext(TemplateContext);
  const [LineasConvocatorias, setLineasConvocatorias] = React.useState([]);
  const [mostrarTabla, setMostrarTabla] = useState(false);

  const toggleVista = () => {
    setMostrarTabla(!mostrarTabla);
  };

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria, data) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) {
      return valueFilter[0].nombre;
    } else {
      if (data.nombre_convocatoria && data.nombre_convocatoria.includes("jurados")) {
        return "Banco de Jurados";
      } else {
        return "BEPS";
      }
    }
  };

  const fields = [
    { name: "perfil_participante", value: principalState.buscarconvocatorias.perfil_participante },
    { name: "area", value: principalState.buscarconvocatorias.area },
    { name: "entidad", value: principalState.buscarconvocatorias.entidad },
    { name: "linea_convocatoria", value: principalState.buscarconvocatorias.linea_convocatoria },
    { name: "categoria_linea_convocatoria", value: principalState.buscarconvocatorias.categoria_linea_convocatoria },
    { name: "buscar_palabra_clave", value: principalState.buscarconvocatorias.buscar_palabra_clave },
    { name: "tipo_convocatoria", value: principalState.buscarconvocatorias.tipo_convocatoria },
    { name: "anio", value: principalState.buscarconvocatorias.anio },
 ];

  const datosTabla = principalState.convocatoriasslice
  .filter((data: any) => data.entidad == "PP")
  .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias)
  .map((data: any) => ({
    // Mapear aquí los datos que quieres mostrar en la tabla
    idconvocatorias: data.idconvocatorias,
    nombre_convocatoria: data.nombre_convocatoria,
    fechas: data.fechas,
    estado: data.estado,
    entidad: data.entidad,
    linea_convocatoria: data.linea_convocatoria,
    tipo_participante: data.tipo_participante,
    area: data.area
  }));

  const columns = [
    {
      title: "Nombre convocatoria",
      width: 300,
      dataIndex: "nombre_convocatoria",
      key: "nombre_convocatoria",
      render: (datos) => {
        return (
          <span style={{whiteSpace: "pre-line"}}>
            {datos}
          </span>
        );
      },
    },
    {
      title: "Línea convocatoria",
      width: 450,
      render: (datos) => {
        return (
          <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line" , fontWeight: "bold"}}>
            {getFilterLineaConvocatoria(datos?.linea_convocatoria, datos) !== undefined ? `${getFilterLineaConvocatoria(datos?.linea_convocatoria, datos)}` : ""}
          </span>
        );
      },
    },
    {
      title: "Fecha apertura",
      width: 120,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechaapertura = datos.fechas.filter(
            (data) => data.clave === "Apertura"
          );
          if (fechaapertura.length > 0) {
            fecha = fechaapertura[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Fecha cierre",
      width: 100,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechacierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );
          if (fechacierre.length > 0) {
            fecha = fechacierre[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Tipo participante",
      width: 100,
      render: (datos) => {
        if (Array.isArray(datos.tipo_participante)) {
          var tipo_participante = ""
          datos.tipo_participante.forEach((tipo) => {
            tipo_participante += tipo.text + " - ";
          });
        }
        return <span className="font-family-Montserrat-Regular">{tipo_participante}</span>;
      }
    },
    {
      title: "Estado",
      width: 100,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechaCierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );

          if (fechaCierre.length > 0) {
            fecha = fechaCierre[0].valormax

            let fechaActual = new Date();
            let anio = fechaActual.getFullYear();
            let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2)
            let dia = ('0' + fechaActual.getDate()).slice(-2);
            let hora = ('0' + fechaActual.getHours()).slice(-2);
            let minutos = ('0' + fechaActual.getMinutes()).slice(-2);

            let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;

            let cierreAct = new Date(fecha);
            cierreAct.setHours(cierreAct.getHours() - 1);
            let anioc = cierreAct.getFullYear();
            let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
            let diac = ('0' + cierreAct.getDate()).slice(-2);
            let horac = ('0' + cierreAct.getHours()).slice(-2);
            let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
            let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

            if (fechaYHoraActualizada <= fechaYHora){
              var estadoAct = 'Cerrada'
            } else {
              estadoAct = datos.estado
            }
          }
        }
        return (<span style={{ color: coloresEstado[estadoAct], marginLeft: "0" }}>
                  {estadoAct}
                </span>)
      },
    },
    {
      title: "Entidad",
      width: 100,
      dataIndex: "entidad",
      key: "entidad",
    },
    {
      title: "Áreas",
      width: 200,
      render: (datos) => {
        if (Array.isArray(datos.area)) {
          let area = "";
          datos.area.forEach((tipo, index) => {
            area += tipo.text;
            if (index < datos.area.length - 1) {
              area += ", ";
            } else {
              area += ".";
            }
          });
          return <span className="font-family-Montserrat-Regular" style={{ whiteSpace: "pre-line" }}>{area}</span>;
        }
        return null;
      }
    }
  ];

  const handleRowClick = (record: any) => {
    window.open(`/estimuloscultura/verconvocatoria/${record.idconvocatorias}`, "_blank", "noopener,noreferrer")
  };

  // component mounted
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getConvocatorias();
    }
    return () => {
      mounted = false;
    };
  }, []);
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const [visualizarCronograma, setVisualizarCronograma] = useState<boolean>(false);
  const [visualizarPortafolio, setVisualizarPortafolio] = useState<boolean>(false);
  const [visualizarSocializaciones, setVisualizarSocializaciones] = useState<boolean>(false);

  const mostrarModalCronograma = () => {
    setVisualizarCronograma(true);
  }

  const mostrarModalPortafolio = () => {
    setVisualizarPortafolio(true);
  }

  const mostrarModalSocializaciones = () => {
    setVisualizarSocializaciones(true);
  }

  const contentStyle: React.CSSProperties = {
    width: '100%',
    objectFit: 'cover'
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 770);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 770);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const contentStyleC: React.CSSProperties = {
    width: "100%",
    height: "auto",
    objectFit: "cover"
  };

  const carouselRef = useRef<any>(null);
  const goToPrev = () => carouselRef.current?.prev();
  const goToNext = () => carouselRef.current?.next();

  return (
    <div>
      <Header />
      <HeaderPp />
      <div style={{ position: "relative", margin: "0 auto" }}>
        <Carousel
          ref={carouselRef}
          autoplay
          autoplaySpeed={3000}
          dots
          infinite
        >
          <div>
            <img src={segundaDesktop} alt="Banner 1" style={contentStyleC} />
          </div>
          <div>
            <img src={banner2} alt="Banner 2" style={contentStyleC} />
          </div>
          <div>
            <img src={banner3} alt="Banner 3" style={contentStyleC} />
          </div>
        </Carousel>
        {/* Flechas */}
        <button
          onClick={goToPrev}
          style={{
            position: "absolute",
            top: "50%",
            left: "16px",
            transform: "translateY(-50%)",
            background: "rgba(0,0,0,0.5)",
            border: "none",
            color: "white",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            cursor: "pointer"
          }}
        >
          <LeftOutlined style={{ fontSize: "18px" }} />
        </button>
        <button
          onClick={goToNext}
          style={{
            position: "absolute",
            top: "50%",
            right: "16px",
            transform: "translateY(-50%)",
            background: "rgba(0,0,0,0.5)",
            border: "none",
            color: "white",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            cursor: "pointer"
          }}
        >
          <RightOutlined style={{ fontSize: "18px" }} />
        </button>
      </div>
      <div className="container-fluid2 pt-5" style={{marginTop: '0'}}>
        <div className="font-family-Montserrat text-center font-color-black" style={{fontSize:60}}>
          <strong>
            <h1 className="mb-5" style={{color: '#1e3a53'}}>
              Fortalecimiento al Sector Cultural
            </h1>
          </strong>
          <h4 className="mb-3" style={{textAlign: 'center', marginTop: '10px'}}>
            Este componente busca consolidar el sector cultural en las comunas y corregimientos de Medellín mediante el fortalecimiento de artistas, gestores, organizaciones y redes. Sus acciones incluyen la formulación de planes de desarrollo cultural, la dinamización de redes y colectivos, y la oferta de diplomados en gestión cultural y otros temas relevantes.
          </h4>
        </div>
      </div>
      <br />
      <div className="container-fluid2 pt-5">
        <div className="row justify-content-center">
          <div className="col-md-3">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={observatorio}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Observatorio</h3>
                  <p className="card2-description">
                    Es una herramienta que sirve para observar y analizar tendencias en un área específica. Tiene claro qué estudia, cómo lo hace y con qué principios. Su objetivo es ofrecer información con una mirada crítica, independiente y diversa. Funciona como un centro de ideas que promueve el análisis y la difusión de lo que descubre sobre el tema que investiga.
                  </p>
                  <p className="card2-description">
                    El observatorio se desarrolla en tres etapas, pero solo se podrá ejecutar una por vigencia o anualidad.
                  </p>
                  <p className="card2-description">
                    <strong>Nota:</strong> Al finalizar alguna de estas actividades, se podrá realizar una muestra artística
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={investigacion}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Investigación en Fortalecimiento al Sector Cultural.</h3>
                  <p className="card2-description">
                    Consiste en un proceso metódico, sistemático y ordenado, cuyo propósito es responder preguntas, teorías o hipótesis relacionadas con el fortalecimiento del sector cultural en las comunas y corregimientos de Medellín. Su desarrollo permite la generación de conocimiento y la obtención de información relevante.
                  </p>
                  <p className="card2-description">
                    <strong>Nota:</strong> Al finalizar alguna de estas actividades, se podrá realizar una muestra artística
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={planes}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Planes de trabajo o gestión.</h3>
                  <p className="card2-description">
                  Es una herramienta de planeación que permite a organizaciones, colectivos, mesas y agrupaciones culturales operar de manera articulada, coordinada e integral. Incluye la definición de objetivos, directrices, políticas, estrategias, metas y acciones para fortalecer el sector cultural.
                  </p>
                  <p className="card2-description">
                    La formulación del plan de trabajo contempla 3 etapas fundamentales:
                  </p>
                  <p className="card2-description">
                    - Formulación
                  </p>
                  <p className="card2-description">
                    - Ejecución
                  </p>
                  <p className="card2-description">
                    - Evaluación
                  </p>
                  <p className="card2-description">
                    <strong>Nota:</strong> Al finalizar alguna de estas actividades, se podrá realizar una muestra artística
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={observatorio}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Fortalecimiento del tejido cultural - Encuentros de aprendizaje</h3>
                  <p className="card2-description">
                    Busca fortalecer los procesos pedagógicos y el intercambio de saberes dentro del sector cultural a través de diferentes formatos de aprendizaje:
                  </p>
                  <p className="card2-description">
                    - Diplomados
                  </p>
                  <p className="card2-description">
                    - Seminarios
                  </p>
                  <p className="card2-description">
                    - Conferencias
                  </p>
                  <p className="card2-description">
                    - Encuentros Formativos
                  </p>
                  <p className="card2-description">
                    - Foros
                  </p>
                  <p className="card2-description">
                    - Simposios
                  </p>
                  <p className="card2-description">
                    - Tertulias
                  </p>
                  <p className="card2-description">
                    - Diálogos de Saberes
                  </p>
                  <p className="card2-description">
                    - Conversatorios
                  </p>
                  <p className="card2-description">
                    <strong>Nota:</strong> Al finalizar alguna de estas actividades, se podrá realizar una muestra artística
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalVisualizarCronograma
        visualizar={visualizarCronograma}
        setVisualizar={setVisualizarCronograma}
      />
      <ModalVisualizarPortafolio
        visualizar={visualizarPortafolio}
        setVisualizar={setVisualizarPortafolio}
      />
      <ModalVisualizarSocializaciones
        visualizar={visualizarSocializaciones}
        setVisualizar={setVisualizarSocializaciones}
      />
      <Footer />
    </div>
  );
};
